import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/human-dummy-practice.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-440c5680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "content w-full bg-white" }
const _hoisted_3 = { class: "t-test-practice__content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"flex hide-desktop-flex\" data-v-440c5680><div class=\"t-test-practice__content__hint\" data-v-440c5680><p class=\"text-primary-gc text-sm p-4\" data-v-440c5680> Pilih jawaban dengan mengklik salah satu lingkaran di bawah pertanyaan </p><img class=\"t-test-practice__content-image mt-16\" src=\"" + _imports_0 + "\" data-v-440c5680></div></div><div class=\"flex justify-content-end hide-mobile-flex\" data-v-440c5680><div class=\"t-test-practice__content__hint\" data-v-440c5680><p class=\"text-primary-gc text-sm p-4 md:p-0\" data-v-440c5680> Pilih jawaban dengan mengklik salah satu lingkaran di bawah pertanyaan </p></div><img class=\"t-test-practice__content-image\" src=\"" + _imports_0 + "\" data-v-440c5680></div>", 2)
const _hoisted_6 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-24 lg:h-56 w-full bg-gray-200 rounded-md" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "t-test-practice__content__test d-flex flex-column"
}
const _hoisted_10 = { class: "t-test-practice__content__test__question" }
const _hoisted_11 = { class: "text-primary-gc text-xl text-center font-semibold mb-2" }
const _hoisted_12 = { class: "text-xl text-center font-semibold" }
const _hoisted_13 = { class: "t-test-practice__content__test__answer" }
const _hoisted_14 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "d-flex flex-row" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex flex-row justify-content-between hide-desktop-flex" }
const _hoisted_19 = { class: "t-test-practice__content__test__action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GcHeader = _resolveComponent("GcHeader")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_GcHeader, { "profile-data": _ctx.profileData }, null, 8, ["profile-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.filteredTestQuestion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, " Latihan Soal " + _toDisplayString(_ctx.currentQuestionIndex + 1), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.filteredTestQuestion.question), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.filteredTestQuestion.answer_type)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTestQuestion.answer_type
                .answers, (answer, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: answer.id,
                          class: "col"
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("hr", {
                                class: _normalizeClass(["separator", { 'separator--transparent': index == 0 }])
                              }, null, 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([
                        'circle',
                        _ctx.answeredQuestion === answer.id ? 'active' : '',
                      ]),
                                onClick: ($event: any) => (_ctx.setAnswer(answer))
                              }, null, 10, _hoisted_17),
                              _createElementVNode("hr", {
                                class: _normalizeClass([{
                        'separator--transparent':
                          index ==
                          _ctx.filteredTestQuestion.answer_type.answers.length - 1,
                      }, "separator"])
                              }, null, 2)
                            ]),
                            (
                      index === 0 ||
                      index ===
                        _ctx.filteredTestQuestion.answer_type.answers.length - 1
                    )
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(`${
                      index === 0
                        ? 'text-error-text-gc pl-14'
                        : 'text-primary-gc pr-20'
                    } text-sm font-semibold mt-4 hide-mobile`),
                                  style: _normalizeStyle({ textAlign: index === 0 ? 'left' : 'right' })
                                }, _toDisplayString(answer.answer), 7))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTestQuestion.answer_type
                .answers, (answer, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: answer.id
                        }, [
                          (
                  index === 0 ||
                  index === _ctx.filteredTestQuestion.answer_type.answers.length - 1
                )
                            ? (_openBlock(), _createElementBlock("p", {
                                key: index,
                                class: _normalizeClass(`${
                  index === 0 ? 'text-error-text-gc' : 'text-primary-gc'
                } text-sm font-semibold mt-4`),
                                style: _normalizeStyle({ textAlign: index === 0 ? 'left' : 'right' })
                              }, _toDisplayString(answer.answer), 7))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.testQuestion.length === _ctx.currentQuestionIndex + 1)
                ? (_openBlock(), _createBlock(_component_BButton, {
                    key: 0,
                    variant: "warning",
                    class: "text-center text-sm font-semibold py-2 px-8",
                    onClick: _ctx.startTest
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mulai Tes ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_BButton, {
                    key: 1,
                    disabled: _ctx.isFilled,
                    variant: "warning",
                    class: "text-center text-sm font-semibold py-2 px-8",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextQuestion(_ctx.filteredTestQuestion)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Lanjutkan "),
                      _createVNode(_component_FontAwesomeIcon, {
                        class: "ml-2",
                        icon: "chevron-right"
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}